import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { applyElementChanges, ApplyElementChangesBody } from '../api/reports.api';
import { REPORT_DETAIL_QUERY_KEY } from '../constants/reports-query-keys';

export const useApplyElementChanges = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: ({ reportId, body }: { reportId: string; body: ApplyElementChangesBody }) =>
      applyElementChanges(reportId, body),
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: REPORT_DETAIL_QUERY_KEY(data.id) });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(error, 'authenticated.reports:toasts.aiApplyError');
    },
  });
};
